/**
 * WOWO aka Wire ON Wire OFF.
 * show/hide sub-modules based of the flags dictionary.
 */
const WOWO = (typeof window !== 'undefined' && window.WOWO) || {};

export default WOWO;
